import { status } from '@/helpers/async';
import { getChallenges } from '@/helpers/api';

import createStore from '@/helpers/items';
import { shareChallengeUrl } from '@/helpers/routes';

import { safePush } from '@/store/actions/routing';
import { $private } from '@/helpers/test';

const didFetchItems = (items) => {
    return {
        type: 'challenges/FETCH',
        data: items,

        status: status.SUCCESS
    };
};

export const selectItemById = (challenge) => (dispatch) => {
    dispatch(safePush(shareChallengeUrl(challenge)));
};

export const fetchMany = () => (dispatch) => {
    dispatch({ type: FETCH, status: status.REQUEST });
    return getChallenges()
        .then((response) => response.data.challenges)
        .then((items) => dispatch(didFetchItems(items)));
};

$private(module, didFetchItems);

export const { FETCH, initialState } = createStore('challenges', fetchMany);
